import { ContentSettings, IComponentProperties } from '@report-content';

export function contentSettingsToComponentProperties(contentSettings: ContentSettings): IComponentProperties {
    return {
        elementId: contentSettings.elementId,
        segmentValueId: contentSettings.segmentValueId,
        context: contentSettings.context,
        applyAccessMap: contentSettings.applyAccessMap,
        forScreenShot: contentSettings.forScreenShot,
        pageSize: contentSettings.pageSize,
        measurement_time: contentSettings.measurement_time,
    };
}
